export default defineNuxtPlugin((nuxtApp) => {
  const { status } = useAuth()
  const router = useRouter()

  watch(status, (current, previous) => {
    const route = router.currentRoute.value
    if (previous !== "authenticated" || current !== "unauthenticated" || route.meta["auth"] === false) return

    // A full navigation also discards cached data from the invalidated session.
    void nuxtApp.runWithContext(() =>
      navigateTo({ path: "/login", query: { callbackUrl: route.fullPath } }, { external: true, replace: true })
    )
  })
})
